// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__yafgT","title":"styles_title__fUnLg","button":"styles_button__qbQt6"};